import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    SkipSelf,
} from '@angular/core';
import {
    ControlContainer,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipComponent } from 'app/components/tooltip/tooltip.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ForbiddenCharsDirective } from 'app/shared/forbidden-chars.directive';

@Component({
    selector: 'revamp-input-general',
    templateUrl: './revamp-input-general-application.component.html',
    styleUrls: ['./revamp-input-general-application.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        TooltipComponent,
        MatTooltipModule,
        ForbiddenCharsDirective,
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
})
export class RevampInputGeneralApplicationComponent implements OnChanges {
    @Input() label: string | null = null;
    @Input() currentValue: string = '';
    @Input() placeHolder: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() mandatoryField: boolean = false;
    @Input() inputType: string = 'text';
    @Input() hideInput: boolean = false;
    @Input() resetPasswordButton: boolean = false;
    @Input() resetMobileButton: boolean = false;
    @Input() verifyMobileButton: boolean = false;
    @Input() class: string = '';
    @Input() removeValue: boolean = false;
    @Input() backgroundOverride: string | undefined;
    @Input() businessInfoProfile: boolean = false;
    @Input() applyDisableText: boolean = false;

    @Input() errors: string[] = [];
    @Input() strength: null | number = null;

    @Input() strengthLabel: null | string = null;
    @Input() strengthColor: string = '#4b6eec';
    @Input() classOverrides: string | null = null;
    @Input() controlName?: string;
    @Input() maxlength: any;
    @Input() phoneNoCodeLabel?: string = undefined;
    @Output() phoneNoFieldChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() resetMobile: EventEmitter<any> = new EventEmitter<any>();
    @Output() verifyMobile: EventEmitter<any> = new EventEmitter<any>();
    @Output() resetPassword: EventEmitter<any> = new EventEmitter<any>();
    @Input() verifyButton?: boolean = false;
    @Input() verifyCompanyRegNoLoading?: boolean = false;
    @Input() verifyIdentificationNoLoading?: boolean = false;
    @Input() verifyIdentificationNoBtn?: boolean = false;
    @Input() VerifiedIdentificationNo;
    @Input() disableCompanyRegVerifyBtn: boolean = false;
    @Input() disableIdentificationVerifyBtn: boolean = false;
    @Output() isCompanyRegNoVerified: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() isIdentificationNoVerified: EventEmitter<any> =
        new EventEmitter<any>();
    @Input() buttonVerified?: boolean = false;
    @Input() identificationNoButtonVerified?: boolean = false;
    @Input() radioSelect?: boolean = false;
    @Input() radioSelectDesignation?: string = '';
    @Input() radioSelectName?: string = '';
    @Input() headerUnderline: boolean = false;
    @Input() tooltipDataHeading: any;
    @Input() TooltipData = {
        header: '',
        content: '',
        content2: '',
    };
    isTooltipOpenHeader: boolean = false;
    strengthArray = [0, 1, 2, 3];

    hide: boolean;

    isFocus: boolean = false;

    constructor(
        public router: Router,
        public translate: TranslateService,
        private el: ElementRef
    ) {
        this.hide = this.hideInput; // Set the initial value of hide based on hideInput
    }

    toggleHideInput() {
        this.hide = !this.hide;
    }

    toggleTooltipHeader() {
        this.isTooltipOpenHeader = !this.isTooltipOpenHeader;
    }

    toggleVerifyButton() {
        let verifyButton = this.verifyButton;
        this.verifyButton = verifyButton;
        let buttonVerified = this.buttonVerified;
        this.buttonVerified = buttonVerified;
        this.isCompanyRegNoVerified.emit(true);
    }

    onBRNVerified() {
        let buttonVerified = this.buttonVerified;
        this.buttonVerified = buttonVerified;
        let verifyButton = this.verifyButton;
        this.verifyButton = verifyButton;
    }

    onKYCVerified() {
        let identificationNoButtonVerified =
            this.identificationNoButtonVerified;
        this.identificationNoButtonVerified = identificationNoButtonVerified;
        let verifyIdentificationNoBtn = this.verifyIdentificationNoBtn;
        this.verifyIdentificationNoBtn = verifyIdentificationNoBtn;
    }

    toggleIdentificationVerifyButton() {
        let identificationNoButtonVerified =
            this.identificationNoButtonVerified;
        this.identificationNoButtonVerified = identificationNoButtonVerified;
        let verifyIdentificationNoBtn = this.verifyIdentificationNoBtn;
        this.verifyIdentificationNoBtn = verifyIdentificationNoBtn;
        this.isIdentificationNoVerified.emit(true);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.hideInput?.currentValue === true) {
            this.hide = true;
        }
    }

    hideTooltip() {
        this.isTooltipOpenHeader = false;
    }

    resetPass() {
        this.resetPassword.emit(true);
    }

    resetMobilePhone() {
        this.resetMobile.emit(true);
    }

    verifyMobileNo() {
        this.verifyMobile.emit(true);
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        if (!this.el.nativeElement.contains(event.target)) {
            this.isTooltipOpenHeader = false;
        }
    }

    onFocus() {
        this.isFocus = true;
    }

    onBlur() {
        this.isFocus = false;
    }
}
